<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-6">
                    <dl class="row mb-0 font-size-14">
                        <dt class="col-sm-4">Codigo</dt>
                        <dd class="col-sm-8">: {{data.codigo}}</dd>

                        <dt class="col-sm-4">Nombres</dt>
                        <dd class="col-sm-8">: {{data.nombres}}</dd>

                        <dt class="col-sm-4">DNI</dt>
                        <dd class="col-sm-8">: {{data.dni}}</dd>
                    </dl>
                </div>
                <div  class="col-md-6">
                    <dl class="row mb-0 font-size-14">
                        <!--<dt class="col-sm-4">Ultima Matricula registrada en el sistema interno</dt>
                        <dd class="col-sm-8">: {{data.matricula_actual}}</dd>-->

                        <dt class="col-sm-4">Modalidad</dt>
                        <dd class="col-sm-8">: {{data.modalidad}}</dd>

                    </dl>
                </div>
            </div>
            <div class="row font-size-12">
                <table class="table">
                    <thead>
                        <th>ID</th>
                        <th>Indicador</th>
                        <th >Valor</th>
                        <th >Observacion</th>
                        <th >Archivos</th>
                    </thead>
                    <tbody>
                    <tr v-for="(data,index) in data.indicadores"  v-bind:key="index">
                        <td>
                            {{ data.indicador_id }}
                        </td>
                        <td>
                            {{ data.nombre  }}
                        </td>
                        <td >
                            {{data.valor}}
                        </td>
                        <td>
                            {{data.notas}}
                        </td>
                        <td>
                            <div class="container" >
                                <div  style="display: inline-block" v-for="(data2, index2) in data.archivos"
                                      v-bind:key="index2">

                                    <a :href="server + '/storage/' + data2.nombre" target="_blank"  v-b-tooltip.hover :title="data2.nombre_original" >
                                        <i
                                                class="mdi mdi-cloud-download mr-1"
                                                style="font-size: 20px;color: #000000"
                                        /></a>
                                </div>
                            </div>
                        </td>
                    </tr>

                    </tbody>
                </table>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "estudiante-info",
        props: {
            data:{
                type:Object
            }
        },
        data() {
            return {
                server:process.env.VUE_APP_BACKEND,
            }
        }
    }
</script>

<style scoped>

</style>